export const pluralize = (word: string, count: number): string => {
  return Math.abs(count) === 1 ? word : `${word}s`;
};
